import { gql } from '@apollo/client';
import type { EventFollows } from '../../../graphql/rest-link/types';

export const GET_EVENT_FOLLOWS = gql`
  query getEventFollows($eventId: ID!, $queryParams: String) {
    getEventFollows(eventId: $eventId, queryParams: $queryParams)
      @rest(
        type: "EventFollows"
        path: "/v2/api/follows/{args.eventId}?{args.queryParams}"
        method: "GET"
        endpoint: "bff"
      ) {
      data
    }
  }
`;

export type GetEventFollowsVariables = {
  eventId?: number;
  queryParams: string;
};

export type GetEventFollowsData = {
  getEventFollows: EventFollows;
};
